var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    _vm.tag,
    _vm._g(
      { tag: "component", class: [_vm.linkClass, _vm.customClasses] },
      _vm.$listeners
    ),
    [
      _c(
        "span",
        { staticClass: "link__content" },
        [
          _vm._t("default"),
          _vm.slot != undefined
            ? _vm._t("icon", [
                _c("icon", {
                  attrs: {
                    viewBox: "0 0 24 24",
                    size: "20px",
                    name: "arrow_long_right"
                  }
                })
              ])
            : _vm._e()
        ],
        2
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }